import styled from 'styled-components';
import { StyledCell } from 'components/base/Table/Table.styles';
import Icon from 'components/base/Icon';
import useIsFilterSetOwner from '../../../../useIsFilterSetOwner';
import { Tooltip } from '@material-ui/core';
import { getFilterSetTypeText } from '../../../../filter-set.utils';
import { useSelector } from 'react-redux';
import { isAdminSelector } from 'state/selectors/account';

const StyledActionCell = styled(StyledCell)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: default !important;

  & svg {
    margin-right: 1.5rem;
  }
`;

const ActionsCell = ({ Context, filterSet, listHandlers }) => {
  const typeText = getFilterSetTypeText(filterSet);
  const isAdmin = useSelector(isAdminSelector);
  const isOwner = useIsFilterSetOwner(filterSet);
  const permissions = {
    delete: isAdmin || isOwner,
    edit: isOwner
  };

  const onEdit = () => listHandlers?.setFilterSetToEdit(filterSet);
  const onDelete = () => listHandlers?.setFilterSetToDelete(filterSet);

  return (
    <StyledActionCell
      onClick={e => e.stopPropagation()}
      onMouseOver={e => e.stopPropagation()}
    >
      <Tooltip title={`Edit ${typeText}`}>
        <Icon
          name='EditOutlinedIcon'
          color='osloGray'
          onClick={e => {
            onEdit?.();
          }}
          {...(!permissions.edit && { visibility: 'hidden' })}
        />
      </Tooltip>

      <Tooltip title={`Delete ${typeText}`}>
        <Icon
          name='Delete'
          color='darkRed'
          onClick={e => {
            onDelete?.();
          }}
          {...(!permissions.delete && { visibility: 'hidden' })}
        />
      </Tooltip>
    </StyledActionCell>
  );
};

export default ActionsCell;
